import { render, staticRenderFns } from "./MySubscribe.vue?vue&type=template&id=f06c3ac8&scoped=true&"
import script from "./MySubscribe.vue?vue&type=script&lang=js&"
export * from "./MySubscribe.vue?vue&type=script&lang=js&"
import style0 from "./MySubscribe.vue?vue&type=style&index=0&id=f06c3ac8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06c3ac8",
  null
  
)

export default component.exports